<progress-spinner *ngIf="isLoading"></progress-spinner>

<div *ngIf="noDataAvailable && !isLoading">
  <div class="modal-header">
    <div class="title">
      <span class="header"> {{ jmepName }}</span>
    </div>
    <div class="btn-group" (click)="closeDialog()">
      <i class="mdi mdi-close close-icon"></i>
    </div>
  </div>
  <mat-dialog-content fxLayout="row" class="no-data">
    <div>{{ noDataMessage }}</div>
  </mat-dialog-content>
</div>

<div class="result-container" *ngIf="!isLoading && !noDataAvailable">
  <div class="modal-header">
    <div class="title">
      <span class="header"> {{ jmepName }}</span>
    </div>
    <div class="btn-group" (click)="closeDialog()">
      <i class="mdi mdi-close close-icon"></i>
    </div>
  </div>
  <div class="report-header">
    <div class="probe-item">
      <div class="column-label">Port:</div>
      <div class="column-value">
        <mat-select
          class="option-list"
          disabled
          [(ngModel)]="formData.selectedProbe"
          name="probe"
          (selectionChange)="onProbeChange()"
        >
          <mat-option *ngFor="let probe of probeNameList" [value]="probe">{{ probe }}</mat-option>
        </mat-select>
      </div>
    </div>
    <div class="probe-action-items">
      <div class="action-btn" (click)="refreshResults()">
        <div class="icon">
          <span class="material-icons md-16">refresh</span>
        </div>
        <div class="text">Refresh</div>
      </div>
    </div>
  </div>

  <div class="result-content" *ngIf="summaryDataSource.length > 0">
    <div class="probe-title">Summary</div>
    <div class="probe-table">
      <mat-table [dataSource]="summaryDataSource">
        <!-- Period Start Time Column -->
        <ng-container matColumnDef="periodStartTime">
          <mat-header-cell *matHeaderCellDef> Start Time(UTC) </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.periodStartTime | date: 'MM/dd/yyyy HH:mm:ss':'UTC' }}
          </mat-cell>
        </ng-container>

        <!-- Monitor Period End Time Column -->
        <ng-container matColumnDef="monitorPeriodEndTime">
          <mat-header-cell *matHeaderCellDef> End Time(UTC) </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.monitorPeriodEndTime | date: 'MM/dd/yyyy HH:mm:ss':'UTC' }}
          </mat-cell>
        </ng-container>

        <!-- Monitored Time Column -->
        <ng-container matColumnDef="monitoredTime">
          <mat-header-cell *matHeaderCellDef> Monitored Time </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.monitoredTime }} </mat-cell>
        </ng-container>

        <!-- Granularity Column -->
        <ng-container matColumnDef="granularity">
          <mat-header-cell *matHeaderCellDef> Granularity </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.granularity }} </mat-cell>
        </ng-container>

        <!-- Sample Interval Column -->
        <ng-container matColumnDef="sampleInterval">
          <mat-header-cell *matHeaderCellDef> Traffic Sample Interval </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.sampleInterval }} </mat-cell>
        </ng-container>

        <!-- Period Status Column -->
        <ng-container matColumnDef="periodStatus">
          <mat-header-cell *matHeaderCellDef> Period Status </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.periodStatus }} </mat-cell>
        </ng-container>

        <!-- Time Unsync Column -->
        <ng-container matColumnDef="timeUnsync">
          <mat-header-cell *matHeaderCellDef> Time Unsync Flag </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.timeUnsync }} </mat-cell>
        </ng-container>

        <!-- Header and Row Declarations -->
        <mat-header-row *matHeaderRowDef="displayedColumns1"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns1"></mat-row>
      </mat-table>
    </div>
  </div>

  <div class="result-content" *ngIf="interfaceDataSource">
    <div class="probe-title">Traffic Report</div>
    <div class="probe-table">
      <table mat-table [dataSource]="interfaceDataSource">
        <!-- Group Headers -->
        <ng-container matColumnDef="interfaceGroup">
          <th mat-header-cell *matHeaderCellDef colspan="1" class="header-group"></th>
        </ng-container>
        <ng-container matColumnDef="framesGroup">
          <th mat-header-cell *matHeaderCellDef colspan="2" class="header-group">Frames</th>
        </ng-container>

        <ng-container matColumnDef="octetsGroup">
          <th mat-header-cell *matHeaderCellDef colspan="3" class="header-group">Octets</th>
        </ng-container>

        <ng-container matColumnDef="microburstGroup">
          <th mat-header-cell *matHeaderCellDef colspan="19" class="header-group">Microburst</th>
        </ng-container>

        <ng-container matColumnDef="interface">
          <th mat-header-cell *matHeaderCellDef>Interface</th>
        </ng-container>

        <!-- Columns -->
        <ng-container matColumnDef="interface">
          <th mat-header-cell *matHeaderCellDef>Interface</th>
          <td mat-cell *matCellDef="let element">{{ element.interface }}</td>
        </ng-container>

        <!-- Frames Columns -->
        <ng-container matColumnDef="frames">
          <th mat-header-cell *matHeaderCellDef>Rx Frames</th>
          <td mat-cell *matCellDef="let element" [matTooltip]="element.originalValues.frames">
            {{ element.frames }}
          </td>
        </ng-container>

        <ng-container matColumnDef="excludedFrames">
          <th mat-header-cell *matHeaderCellDef>Excluded Frames</th>
          <td
            mat-cell
            *matCellDef="let element"
            [matTooltip]="element.originalValues.excludedFrames"
          >
            {{ element.excludedFrames }}
          </td>
        </ng-container>

        <!-- Octets Columns -->
        <ng-container matColumnDef="octets">
          <th mat-header-cell *matHeaderCellDef>Rx Octets</th>
          <td mat-cell *matCellDef="let element" [matTooltip]="element.originalValues.octets">
            {{ element.octets }}
          </td>
        </ng-container>

        <ng-container matColumnDef="excludedOctets">
          <th mat-header-cell *matHeaderCellDef>Excluded Octets</th>
          <td
            mat-cell
            *matCellDef="let element"
            [matTooltip]="element.originalValues.excludedOctets"
          >
            {{ element.excludedOctets }}
          </td>
        </ng-container>

        <ng-container matColumnDef="peakOctets">
          <th mat-header-cell *matHeaderCellDef>Peak Octets</th>
          <td mat-cell *matCellDef="let element" [matTooltip]="element.originalValues.peakOctets">
            {{ element.peakOctets }}
          </td>
        </ng-container>

        <!-- Microburst Columns -->
        <ng-container *ngFor="let bin of microburstBins; let i = index" [matColumnDef]="bin">
          <th mat-header-cell *matHeaderCellDef>{{ getBinTitle(binValues[i]) }}</th>
          <td mat-cell *matCellDef="let element" [matTooltip]="element.originalValues[bin]">
            {{ element[bin] }}
          </td>
        </ng-container>

        <!-- Group Header Row -->
        <tr mat-header-row *matHeaderRowDef="groupedColumns"></tr>

        <!-- Data Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>

  <div class="result-content" *ngIf="pmDataSource">
    <div class="probe-table">
      <div class="probe-title">PM Report</div>
      <view-table [attr.id]="pmDataSource.dimension" [dataSource]="pmDataSource"></view-table>
    </div>
  </div>
</div>
